import { render } from "./SecretType.vue?vue&type=template&id=8d71f332"
import script from "./SecretType.vue?vue&type=script&lang=js"
export * from "./SecretType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__